// AuthService.js

import axios from "axios";
import jwtDecode from "jwt-decode";
import AuthService from "@/services/AuthService";
import store from '../store';
const CryptoJS = require("crypto-js");
import keycloakService from "@/services/KeycloakService";
import { REFRESH_TOKEN_KEY } from "@/services/KeycloakService";

const TOKEN_KEY = "jwt";
const instance = axios.create({
  baseURL: process.env.VUE_APP_AUTH_API_URL,
});
export default {
  instance,
  getRole() {
    return localStorage.getItem("userInfo");
  },
  setUserInfo(data){
    // console.log("setuser data",data)
    var stringUserInfo = JSON.stringify(data);

    const encryptedData = CryptoJS.AES.encrypt(
      stringUserInfo,
      process.env.VUE_APP_ENCRYPTION_KEY
    ).toString();   
    localStorage.setItem("userInfo", encryptedData);
  },
  login: async function (email, password) {
    try {
      const response = await instance.post("login", { email, password });

      if (response.status == 200) {
        const token = response.data.data.token;
        // console.log("token",token);
        localStorage.setItem(TOKEN_KEY, token);
        this.setUserInfo(response.data.data)
        return response;
      }
    } catch (error) {
      // console.log("error",error)
      // alert(error);
      alert("Invalid Credentials");

      return false;
    }
  },

  createAdmin: async function (data) {
    try {
      const response = await instance.post("updateAdminUser", data, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  logout: function () {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('userInfo');
    localStorage.removeItem('userType');
    localStorage.removeItem('videoInfo');
    localStorage.removeItem('firstFullPath')
    store.dispatch('clearAllStates');
    keycloakService.doLogout();
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },
  getUser: function () {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      const decoded = jwtDecode(token);
      return decoded.user;
    }
    return null;
  },
  getToken: function () {
    return localStorage.getItem(TOKEN_KEY);
  },
  async isAuthenticated() {
    const token = localStorage.getItem(TOKEN_KEY);
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (token && refreshToken) {
      if (this.isTokenExpired(token)) {
        console.log('token eXpired');
        try {
          const response = await instance.get(`/keycloakAuth/updatedToken?refreshToken=${refreshToken}`);
          
          if (response.status === 200 && response.data.access_token) {
            console.log('New token received', response.data);
            const newToken = response.data.access_token;
            const newRefreshToken = response.data.refresh_token;
  
            localStorage.setItem(TOKEN_KEY, newToken);
            localStorage.setItem(REFRESH_TOKEN_KEY, newRefreshToken);
  
            return true;
          } else {
            console.warn('Failed to refresh token');
            return false;
          }
        } catch (error) {
          console.error('Error while refreshing token:', error);
          return false;
        }
      } else {
        return true;
      }
    }
    // Only token present or none — validate based on that
    return token && !this.isTokenExpired(token);
  },  
  isTokenExpired: function (token) {
    const decoded = jwtDecode(token);
    const expirationDate = new Date(decoded.exp * 1000);
    return expirationDate < new Date();
  },
  doesEmailExist: async function(userType, email){
    try{
      const response = await instance.get(`doesEmailExist?userType=${userType}&email=${email}`);
      return response.data.emailExists;
    }
    catch(error){
      console.error
    }
  },
  checkAdminEmailExist: async function(email){
    try{
      const response = await instance.get(`checkAdminEmailExist?email=${email}`);
      return response.data.emailExists;
    }
    catch(error){
      console.error
    }
  },
  async validateKeycloakToken(code,state) {
    console.log('validate Keyclock', code)
    console.log('validate Keyclock state', state)
    try {
      const key = 'kc-callback-'+ state;
      console.log('key',key)
      const codeVerifierString = localStorage.getItem(key);
      console.log('codeVerifierString',codeVerifierString)
      const codeVerifier = JSON.parse(codeVerifierString);
      const pkceCodeVerifier = codeVerifier.pkceCodeVerifier;
      const authorizationCode = code; 

      const params = new URLSearchParams({
        code: authorizationCode,
        code_verifier: pkceCodeVerifier
      });
      // return;
      const response = await instance.get(`/keycloakAuth/validateUser?${params.toString()}`);
      console.log("validate response", response.data);
      if (response.status == 200) {
        if(response.data.flag){
          console.log('in response flag validate')
            const token = response.data.token;
            const keycloakRefreshToken = response.data.refreshToken;
            localStorage.setItem(TOKEN_KEY, token);
            localStorage.setItem(REFRESH_TOKEN_KEY, keycloakRefreshToken);
            this.setUserInfo(response.data.adminData)
            store.dispatch('setRoleId', response.data.adminData.roleId);
            store.dispatch('setRole', response.data.adminData.role);
            store.dispatch('setUserInfo', response.data.adminData);
            return response.data;
        }else{
          console.log('in response flag else validate',response.data)
           return response.data;
        }
        
      } else {
        console.log('response data',response.data)
        return response.data;
      }
    } catch (error) {
      console.log("validate otp error", error)
    }
  },
};
